import type { ReactNode } from 'react'
import * as ApolloProvider from '@/integrations/apollo/root-provider'
import * as ZustandStoreProvider from '@/integrations/zustand-store/root-provider'
import * as TanStackQueryProvider from '@/integrations/tanstack-query/root-provider'
import * as I18nextProvider from '@/integrations/i18next/root-provider'
import { NotificationCenterProvider } from '@/shared/notifications/notification-center'

export function getAppProviderContext(
  props: Parameters<typeof ZustandStoreProvider.getContext>[0],
) {
  const tanstackQuery = TanStackQueryProvider.getContext()
  const apollo = ApolloProvider.getContext()
  const zustand = ZustandStoreProvider.getContext(props)

  return {
    tanstackQuery,
    apollo,
    zustand,
  }
}

export function AppProviders({
  children,
  context,
}: {
  children: ReactNode
  context: ReturnType<typeof getAppProviderContext>
}) {
  return (
    <I18nextProvider.Provider>
      <ApolloProvider.Provider {...context.apollo}>
        <TanStackQueryProvider.Provider {...context.tanstackQuery}>
          <ZustandStoreProvider.Provider {...context.zustand}>
            <NotificationCenterProvider>{children}</NotificationCenterProvider>
          </ZustandStoreProvider.Provider>
        </TanStackQueryProvider.Provider>
      </ApolloProvider.Provider>
    </I18nextProvider.Provider>
  )
}
